import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { useLanguage } from '@/contexts/LanguageContext';

interface DemoConversionCtaProps {
  variant?: 'inline' | 'sticky';
  className?: string;
}

export function DemoConversionCta({ variant = 'inline', className = '' }: DemoConversionCtaProps) {
  const navigate = useNavigate();
  const { t } = useLanguage();

  const handleStartChallenge = () => {
    navigate('/auth?mode=signup');
  };

  if (variant === 'sticky') {
    return (
      <div 
        className={`fixed left-0 right-0 z-50 bg-background/95 backdrop-blur-sm border-t border-border p-3 ${className}`}
        style={{ bottom: 'env(safe-area-inset-bottom, 0px)' }}
      >
        <div className="max-w-lg mx-auto">
          <Button 
            onClick={handleStartChallenge} 
            className="w-full"
            size="lg"
          >
            {t('demoCta')} →
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div className={`text-center py-4 ${className}`}>
      <Button 
        onClick={handleStartChallenge}
        variant="outline"
        size="sm"
      >
        {t('demoCta')} →
      </Button>
    </div>
  );
}
